import axiosInstance, { EVENT_CODE, EVENT_ID, F_EMAIL, getUserID, PAPERSUBMIT_TEMPLATE, WEB_API } from '../constatns';
import swal from '@sweetalert/with-react';
import UploadToS3 from '../common/UploadToS3';

export const paperAction = (_state, _mode, _id, isComplete) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('evt', EVENT_ID);
    formData.append('evtCode', EVENT_CODE.replace('#', ''));
    formData.append('writer', getUserID(true));
    formData.append('isForeigner', _state.isForeigner);

    //for SendEmail
    formData.append('from', F_EMAIL);
    formData.append('templateName', PAPERSUBMIT_TEMPLATE);

    if (isComplete) {
      formData.append('status', 'Complete');
    }

    for (const [key, value] of Object.entries(_state)) {
      if (
        key === 'presentationType' ||
        key === 'abstractTopic' ||
        key === 'abstractTitle' ||
        key === 'selectPresentingAuthor' ||
        key === 'selectCorrespondingAuthor' ||
        key === 'purposeContent' ||
        key === 'methodsContent' ||
        key === 'resultsContent' ||
        key === 'conclusionContent' ||
        key === 'isAgree1' ||
        key === 'isAgree2'
      ) {
        formData.append(key, value);
      }
      if (key === 'numOfInstitution' || key === 'numOfAuthor') {
        formData.append(key, JSON.stringify(value));
      }
    }

    //figures memo
    if (_state.figuresMemo) {
      for (let i = 0; i < _state.figuresMemo.length; i++) {
        formData.append(`figuresMemo${i + 1}`, _state.figuresMemo[i]);
      }
    }

    if (_mode === 'write') {
      axiosInstance
        .post(`${WEB_API}/paper/`, formData, {
          'Content-Type': 'multipart/form-data',
        })
        .then((res) => {
          paperFileUpload(res.data.paperId, _state).then((fileFormData) => {
            axiosInstance
              .post(`${WEB_API}/paper/mod`, fileFormData, {
                'Content-Type': 'multipart/form-data',
              })
              .then((result) => {
                resolve(result);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          });
        })
        .catch((err) => {
          console.error(err);
          swal('Error occurred while posting your submission. Please retry it.');
          reject(err);
        });
    } else if (_mode === 'modify') {
      formData.append('paperId', _id);
      if (_state.memo) formData.append('memo', _state.memo);

      axiosInstance
        .post(`${WEB_API}/paper/mod`, formData, {
          'Content-Type': 'multipart/form-data',
        })
        .then((_res) => {
          paperFileUpload(_id, _state).then((fileFormData) => {
            axiosInstance
              .post(`${WEB_API}/paper/mod`, fileFormData, {
                'Content-Type': 'multipart/form-data',
              })
              .then((result) => {
                resolve(result);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          });
        })
        .catch((_err) => {
          swal('Error occurred while updating your submission. Please retry it.');
          reject(_err);
        });
    }
  });
};

export const paperFileUpload = async (paperId, _state) => {
  const fileFormData = new FormData();
  fileFormData.append('evt', EVENT_ID);
  fileFormData.append('paperId', paperId);

  // console.log('paperFileUpload State: ', _state);

  let idx = 0;
  let maxFile = 0;

  if (!_state.file) {
    for (let i = 0; i < _state.figures.length; i++) {
      if (_state.figures[i] !== '') {
        if (_state.figures[i] instanceof File) {
          maxFile++;
        }
      }
    }
  }

  return new Promise(async (resolve, reject) => {
    if (!_state.file && maxFile === 0) resolve(fileFormData);
    if (_state.file !== '' && _state.file instanceof File) {
      maxFile++;
      await UploadToS3(_state.file, 'PRS2021/paper', paperId, 'file').then((upload) => {
        fileFormData.append(`file_DUP`, JSON.stringify(upload));
        idx++;
        if (idx === maxFile) {
          resolve(fileFormData);
        }
      });
    }
    // if (maxFile === 0) resolve(fileFormData);
    if (_state.figures) {
      for (let i = 0; i < _state.figures.length; i++) {
        if (_state.figures[i] !== '') {
          if (_state.figures[i] instanceof File) {
            await UploadToS3(_state.figures[i], 'PRS2021/paper', paperId, `figures${i + 1}`).then((upload) => {
              fileFormData.append(`figures${i + 1}_DUP`, JSON.stringify(upload));
              idx++;
              if (idx === maxFile) {
                resolve(fileFormData);
              }
            });
          }
        }
      }
    }
  });
};
